import { handleActions } from 'redux-actions';

import { CAPS, ADDRESIFY_CLEANUP } from '@/constants';

const init = Object.freeze({
  suggestions: { error: false, city: null, region: null, addresses: [] },
});

export default handleActions(
  {
    [CAPS.ADDRESIFY_SUGGESTIONS]: (state, { payload }) => ({ ...state, suggestions: payload.data }),
    [ADDRESIFY_CLEANUP]: () => init,
  },
  init,
);
